export default __webpack_public_path__ + "static/media/recovered.6c165d0d.svg";